import { useMemo } from 'react'

import { useUserOrganization } from '@modules-deprecated/app/organization'

import type { Invoice } from '../../types/invoices/invoice'
import { getMissingEInvoiceDetails } from '../../utils/eInvoices/getMissingEInvoiceDetails'
import { useInvoiceComplianceMode } from '../useInvoiceComplianceMode'

export const useMissingEInvoiceDetailsForInvoice = (invoice: Invoice | undefined) => {
  const { organization } = useUserOrganization()
  const { invoiceComplianceMode } = useInvoiceComplianceMode()

  return useMemo(
    () =>
      getMissingEInvoiceDetails({
        complianceMode: invoiceComplianceMode,
        invoice,
        isCompanyVatExempted: !!organization?.isVatExempted,
      }),
    [invoice, invoiceComplianceMode, organization?.isVatExempted],
  )
}
